import React, { Component } from 'react';
import { connect } from 'react-redux';
import AvaRIEInput from '../fields/input/AvaRIEInput';

import LANGUAGES_CONTROLLER from '../../controllers/languages';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const log = new Logger('INVOICE_LINE', LOG_LEVELS.DEBUG);

class InvoiceLine extends Component {

  //TODO: Make the 3 values a component then we can hide easily when ZZX or use symbols
  render() {
    //log.debug('render(): ', this.props);
    return (
      <ReadOnlyWrapper>
        <div key={this.props.key}>
          <s-row>
            <s-col span="6">
              <table className="borderless">
                <tbody>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_Description')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.Description}
                          value={this.props.formData[this.props.fieldRefs.Description]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_LineVATCode')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.LineVATCode}
                          value={this.props.formData[this.props.fieldRefs.LineVATCode]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_DateOfSupply')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.DateOfSupply}
                          value={this.props.formData[this.props.fieldRefs.DateOfSupply]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_ShipFrom')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.ShipFromCountry}
                          value={this.props.formData[this.props.fieldRefs.ShipFromCountry]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_ShipTo')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.ShipToCountry}
                          value={this.props.formData[this.props.fieldRefs.ShipToCountry]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_CustomerTaxNumber')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.ExtraDocumentData.customertaxnumber}
                          value={this.props.formData[this.props.fieldRefs.ExtraDocumentData.customertaxnumber]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_CustomerTaxNumberCountry')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.ExtraDocumentData.customervatnumbercountry}
                          value={this.props.formData[this.props.fieldRefs.ExtraDocumentData.customervatnumbercountry]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_ClearingPaymentMethod')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.ExtraDocumentData.clearingdocumentpaymentmethod}
                          value={this.props.formData[this.props.fieldRefs.ExtraDocumentData.clearingdocumentpaymentmethod]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_RefundDescription')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.RefundData.RefundDescription}
                          value={this.props.formData[this.props.fieldRefs.RefundData.RefundDescription]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_RefundDescriptionLanguage')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.RefundData.DescriptionLanguage}
                          value={this.props.formData[this.props.fieldRefs.RefundData.DescriptionLanguage]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_RefundDeductionRate')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.RefundData.DeductionRate}
                          value={this.props.formData[this.props.fieldRefs.RefundData.DeductionRate]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_RefundNature')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.RefundData.RefundNatureOfitem}
                          value={this.props.formData[this.props.fieldRefs.RefundData.RefundNatureOfitem]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </s-col>
            <s-col span="6">
              <table className="borderless">
                <tbody>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_Intrastat_Code')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.IntrastatData.IntrastatCode}
                          value={this.props.formData[this.props.fieldRefs.IntrastatData.IntrastatCode]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_Intrastat_ItemType')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.IntrastatData.ItemType}
                          value={this.props.formData[this.props.fieldRefs.IntrastatData.ItemType]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_Intrastat_Qty1')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.IntrastatData.Quantity1}
                          value={this.props.formData[this.props.fieldRefs.IntrastatData.Quantity1]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_Intrastat_Qty2')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.IntrastatData.Quantity2}
                          value={this.props.formData[this.props.fieldRefs.IntrastatData.Quantity2]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_Intrastat_CountryOrigin')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.IntrastatData.CountryOrigin}
                          value={this.props.formData[this.props.fieldRefs.IntrastatData.CountryOrigin]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_Intrastat_DeliveryConditions')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.IntrastatData.DeliveryConditions}
                          value={this.props.formData[this.props.fieldRefs.IntrastatData.DeliveryConditions]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_Intrastat_HarbourArrival')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.IntrastatData.HarbourArrival}
                          value={this.props.formData[this.props.fieldRefs.IntrastatData.HarbourArrival]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_Intrastat_HarbourDispatch')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.IntrastatData.HarbourDispatch}
                          value={this.props.formData[this.props.fieldRefs.IntrastatData.HarbourDispatch]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_Intrastat_RegionArrival')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.IntrastatData.RegionArrival}
                          value={this.props.formData[this.props.fieldRefs.IntrastatData.RegionArrival]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_Intrastat_RegionDispatch')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.IntrastatData.RegionDispatch}
                          value={this.props.formData[this.props.fieldRefs.IntrastatData.RegionDispatch]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_Intrastat_ServiceCode')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName={this.props.fieldRefs.IntrastatData.ServiceCode}
                          value={this.props.formData[this.props.fieldRefs.IntrastatData.ServiceCode]}
                          change={this.props.change}
                        />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </s-col>
          </s-row>
        </div>
      </ReadOnlyWrapper>
    );
  }
}


function mapStateToProps(state, props) {
  return {
    // Almost all components will need to use language strings, so add them to the props from the global state
    languages: state.languages,
  };
}


function mapDispatchersToProps(dispatch) {
  return {
    //TODO: Add dispatchers (actions we expect controllers to perform) here.
  }
}
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(InvoiceLine);
